import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  CountryRiskIndexNarrative,
  GeneralLoadedContent,
  INITIAL_GENERAL_LOADING_CONTENT,
  LoadingRequestStatus,
} from '../../../shared-models';
import { WindowUtilitiesService } from '../../../shared-utilities';
import { WrittenContentLinkActionsType, WrittenContentLinkActionsUnion } from '../../listeners/written-content-anchor-click-listener';
import { IndexInfoPdf } from './index-info-pdf.abstract';

@Component({
  selector: 'grid-ui-index-info-popover',
  templateUrl: './index-info-popover.component.html',
  styleUrls: ['./index-info-popover.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class IndexInfoPopoverComponent extends IndexInfoPdf {
  private readonly windowUtilitiesService = inject(WindowUtilitiesService);
  public readonly activeModal = inject(NgbActiveModal);

  @Input() public closeReason: null | HttpErrorResponse = null;
  @Input() public downloadPathTemplate: string | null = null;
  @Input() public indexNarrative: GeneralLoadedContent<CountryRiskIndexNarrative> = INITIAL_GENERAL_LOADING_CONTENT;

  @ViewChild('sectionsContainer', { read: ElementRef })
  public sectionsElementRef: ElementRef<HTMLDivElement> | null = null;
  @ViewChild('popoverContainer', { read: ElementRef })
  public popoverContainerElementRef: ElementRef<HTMLDivElement> | null = null;

  public readonly RequestStatus = LoadingRequestStatus;
  public showScrollToTop = false;

  public handleWrittenContentLinkAction(action: WrittenContentLinkActionsUnion): void {
    switch (action.type) {
      case WrittenContentLinkActionsType.OPEN_EXTERNAL_LINK:
      case WrittenContentLinkActionsType.OPEN_PORTAL_ROUTE_IN_NEW_TAB:
        this.windowUtilitiesService.openNewTab(action.payload.url);
        break;
      case WrittenContentLinkActionsType.NAVIGATE_TO_PORTAL_ROUTE:
      case WrittenContentLinkActionsType.SHOW_INDEX_INFORMATION:
        this.activeModal.close(action);
    }
  }

  public onScroll(event: any): void {
    this.showScrollToTop = event.target.offsetHeight + event.target.scrollTop >= 900;
  }

  public retryDataLoad(): void {
    this.activeModal.close(this.indexNarrative.error);
  }

  protected readonly anchorLinks: string[] = ['Definition', 'Methodology', 'Sources'];

  public scrollToAnchor(index: number): void {
    if (this.sectionsElementRef) {
      let bookmarkTop = 0;
      for (let i = 0; i < index; i++) {
        bookmarkTop += this.sectionsElementRef.nativeElement.children[i].getBoundingClientRect().height;
      }
      this.sectionsElementRef.nativeElement.scrollTo({ top: bookmarkTop, behavior: 'smooth' });
    }
  }

  public scrollToTopClicked(): void {
    if (this.sectionsElementRef) {
      this.sectionsElementRef.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
      this.showScrollToTop = false;
    }
  }
}
